@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.receipt.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mobile_wallet.feature.receipt.generated.resources/"

internal val Res.string.feature_receipt_account_no: StringResource by lazy {
      StringResource("string:feature_receipt_account_no", "feature_receipt_account_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 58),
      ))
    }

internal val Res.string.feature_receipt_approve_permission_storage: StringResource by lazy {
      StringResource("string:feature_receipt_approve_permission_storage", "feature_receipt_approve_permission_storage", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247, 98),
      ))
    }

internal val Res.string.feature_receipt_approve_permission_storage_receiptDescription:
    StringResource by lazy {
      StringResource("string:feature_receipt_approve_permission_storage_receiptDescription", "feature_receipt_approve_permission_storage_receiptDescription", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69, 177),
      ))
    }

internal val Res.string.feature_receipt_copy_link: StringResource by lazy {
      StringResource("string:feature_receipt_copy_link", "feature_receipt_copy_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 346, 65),
      ))
    }

internal val Res.string.feature_receipt_credited_by: StringResource by lazy {
      StringResource("string:feature_receipt_credited_by", "feature_receipt_credited_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 412, 51),
      ))
    }

internal val Res.string.feature_receipt_dismiss: StringResource by lazy {
      StringResource("string:feature_receipt_dismiss", "feature_receipt_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 464, 43),
      ))
    }

internal val Res.string.feature_receipt_download_complete: StringResource by lazy {
      StringResource("string:feature_receipt_download_complete", "feature_receipt_download_complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 508, 65),
      ))
    }

internal val Res.string.feature_receipt_downloading_receipt: StringResource by lazy {
      StringResource("string:feature_receipt_downloading_receipt", "feature_receipt_downloading_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 574, 71),
      ))
    }

internal val Res.string.feature_receipt_error_specific_transactions: StringResource by lazy {
      StringResource("string:feature_receipt_error_specific_transactions", "feature_receipt_error_specific_transactions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 646, 127),
      ))
    }

internal val Res.string.feature_receipt_from: StringResource by lazy {
      StringResource("string:feature_receipt_from", "feature_receipt_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 774, 36),
      ))
    }

internal val Res.string.feature_receipt_loading: StringResource by lazy {
      StringResource("string:feature_receipt_loading", "feature_receipt_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 811, 43),
      ))
    }

internal val Res.string.feature_receipt_name: StringResource by lazy {
      StringResource("string:feature_receipt_name", "feature_receipt_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 855, 40),
      ))
    }

internal val Res.string.feature_receipt_opening_pdf_failed: StringResource by lazy {
      StringResource("string:feature_receipt_opening_pdf_failed", "feature_receipt_opening_pdf_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 896, 66),
      ))
    }

internal val Res.string.feature_receipt_other: StringResource by lazy {
      StringResource("string:feature_receipt_other", "feature_receipt_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 963, 37),
      ))
    }

internal val Res.string.feature_receipt_paid_to: StringResource by lazy {
      StringResource("string:feature_receipt_paid_to", "feature_receipt_paid_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1001, 43),
      ))
    }

internal val Res.string.feature_receipt_pan_id: StringResource by lazy {
      StringResource("string:feature_receipt_pan_id", "feature_receipt_pan_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1045, 38),
      ))
    }

internal val Res.string.feature_receipt_proceed: StringResource by lazy {
      StringResource("string:feature_receipt_proceed", "feature_receipt_proceed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1084, 43),
      ))
    }

internal val Res.string.feature_receipt_receipt: StringResource by lazy {
      StringResource("string:feature_receipt_receipt", "feature_receipt_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1128, 43),
      ))
    }

internal val Res.string.feature_receipt_share_receipt: StringResource by lazy {
      StringResource("string:feature_receipt_share_receipt", "feature_receipt_share_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1172, 61),
      ))
    }

internal val Res.string.feature_receipt_sharing_link_failed: StringResource by lazy {
      StringResource("string:feature_receipt_sharing_link_failed", "feature_receipt_sharing_link_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1234, 71),
      ))
    }

internal val Res.string.feature_receipt_to: StringResource by lazy {
      StringResource("string:feature_receipt_to", "feature_receipt_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1306, 30),
      ))
    }

internal val Res.string.feature_receipt_transaction_date: StringResource by lazy {
      StringResource("string:feature_receipt_transaction_date", "feature_receipt_transaction_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1337, 68),
      ))
    }

internal val Res.string.feature_receipt_transaction_id: StringResource by lazy {
      StringResource("string:feature_receipt_transaction_id", "feature_receipt_transaction_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1406, 62),
      ))
    }

internal val Res.string.feature_receipt_unique_receipt_link: StringResource by lazy {
      StringResource("string:feature_receipt_unique_receipt_link", "feature_receipt_unique_receipt_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1585, 75),
      ))
    }

internal val Res.string.feature_receipt_unique_receipt_link_copied_to_clipboard: StringResource by
    lazy {
      StringResource("string:feature_receipt_unique_receipt_link_copied_to_clipboard", "feature_receipt_unique_receipt_link_copied_to_clipboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1469, 115),
      ))
    }

internal val Res.string.feature_receipt_view_Receipt: StringResource by lazy {
      StringResource("string:feature_receipt_view_Receipt", "feature_receipt_view_Receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1661, 52),
      ))
    }

internal val Res.string.feature_receipt_view_receipt: StringResource by lazy {
      StringResource("string:feature_receipt_view_receipt", "feature_receipt_view_receipt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1714, 52),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_receipt_account_no", Res.string.feature_receipt_account_no)
  map.put("feature_receipt_approve_permission_storage", Res.string.feature_receipt_approve_permission_storage)
  map.put("feature_receipt_approve_permission_storage_receiptDescription", Res.string.feature_receipt_approve_permission_storage_receiptDescription)
  map.put("feature_receipt_copy_link", Res.string.feature_receipt_copy_link)
  map.put("feature_receipt_credited_by", Res.string.feature_receipt_credited_by)
  map.put("feature_receipt_dismiss", Res.string.feature_receipt_dismiss)
  map.put("feature_receipt_download_complete", Res.string.feature_receipt_download_complete)
  map.put("feature_receipt_downloading_receipt", Res.string.feature_receipt_downloading_receipt)
  map.put("feature_receipt_error_specific_transactions", Res.string.feature_receipt_error_specific_transactions)
  map.put("feature_receipt_from", Res.string.feature_receipt_from)
  map.put("feature_receipt_loading", Res.string.feature_receipt_loading)
  map.put("feature_receipt_name", Res.string.feature_receipt_name)
  map.put("feature_receipt_opening_pdf_failed", Res.string.feature_receipt_opening_pdf_failed)
  map.put("feature_receipt_other", Res.string.feature_receipt_other)
  map.put("feature_receipt_paid_to", Res.string.feature_receipt_paid_to)
  map.put("feature_receipt_pan_id", Res.string.feature_receipt_pan_id)
  map.put("feature_receipt_proceed", Res.string.feature_receipt_proceed)
  map.put("feature_receipt_receipt", Res.string.feature_receipt_receipt)
  map.put("feature_receipt_share_receipt", Res.string.feature_receipt_share_receipt)
  map.put("feature_receipt_sharing_link_failed", Res.string.feature_receipt_sharing_link_failed)
  map.put("feature_receipt_to", Res.string.feature_receipt_to)
  map.put("feature_receipt_transaction_date", Res.string.feature_receipt_transaction_date)
  map.put("feature_receipt_transaction_id", Res.string.feature_receipt_transaction_id)
  map.put("feature_receipt_unique_receipt_link", Res.string.feature_receipt_unique_receipt_link)
  map.put("feature_receipt_unique_receipt_link_copied_to_clipboard", Res.string.feature_receipt_unique_receipt_link_copied_to_clipboard)
  map.put("feature_receipt_view_Receipt", Res.string.feature_receipt_view_Receipt)
  map.put("feature_receipt_view_receipt", Res.string.feature_receipt_view_receipt)
}
